import React, { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import PendingList from './PendingList';
import AddLeaveModel from './AddLeaveModel';
import AddMemberLeave from './AddMemberLeave';

const LeaveTab = () => {
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const toggleModal1 = () => {
    setIsModalOpen1(!isModalOpen1);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-2 ">
          <h5 className="text-muted col-2"></h5>
          <div
            className="col-10 d-flex justify-content-end align-items-center"
            style={{ gap: '20px' }}
          >
            {/* <span className='text-dark'>Balance</span> */}
            {/* <span className='text-muted d-flex align-items-center"'><i className='dripicons-upload mr-2'></i> Export</span> */}
            <Button
              className=""
              outline
              size="sm"
              color="primary"
              onClick={toggleModal}
            >
              Add leave for a member
            </Button>
            {/* <Button className="" size="sm" color="dark" onClick={toggleModal}>
              + Add Leave
            </Button> */}
          </div>
        </div>
        <div className="container-fluid">
          {isModalOpen && (
            <AddLeaveModel open={isModalOpen} onClose={toggleModal} />
          )}
          {isModalOpen1 && (
            <AddMemberLeave
              open={isModalOpen1}
              onClose={toggleModal1}
              id={false}
            />
          )}
          <div className="row">
            <div className="col-12">
              <div className="card m-b-10">
                <div className="card-body">
                  <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        data-toggle="tab"
                        href="#pending1"
                        role="tab"
                      >
                        <span className="d-none d-md-block">Pending</span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-home-variant h5"></i>
                        </span>
                      </a>
                    </li>
                    {/* <li className="nav-item">
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        href="#approved2"
                        role="tab"
                      >
                        <span className="d-none d-md-block">Approved</span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-account h5"></i>
                        </span>
                      </a>
                    </li> */}
                    {/* <li className="nav-item">
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        href="#rejected3"
                        role="tab"
                      >
                        <span className="d-none d-md-block">Rejected</span>
                        <span className="d-block d-md-none">
                          <i className="mdi mdi-account h5"></i>
                        </span>
                      </a>
                    </li> */}
                  </ul>

                  <div className="tab-content">
                    <div
                      className="tab-pane active"
                      id="pending1"
                      role="tabpanel"
                    >
                      <PendingList />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default LeaveTab;
